import React, { useRef }  from 'react';
import { Card, Table, Button } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useReactToPrint } from 'react-to-print';
/*
const transformData = (data) => {
  return data.filter(item => item.stakeholder != '') 
    .map(kpi => ({
    ambito: kpi.kpiKey.substring(0,7),
    ricaduta: (kpi.kpiKey.substring(8,10)=='R1') ? 'I':'F',
    azione: kpi.kpiKey.substring(14,16),
    stakeholder: kpi.stakeholder,
    descrizione: kpi.descrizione,
    valore: kpi.perCorrValore
  }));
};
*/
const ValoreAggiuntoRiattribuito = () => {
const contentRef = useRef(null);
// const handleScatterPrint = useReactToPrint({ contentRef });


  const handleScatterPrint = useReactToPrint({
    contentRef,
    documentTitle: 'Doppia matrice di materialità',
    pageStyle: `@media print {
      @page {
        size: A4 portrait;
        margin: 10mm;
      }
      body {
        width: 100%;
        margin: 0;
        padding: 0;
        -webkit-print-color-adjust: exact;
      }
      #scatter-print {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        transform: scale(0.40); /* Adjust scale as needed */
        transform-origin: top left;
      }
    }`,
  });



  const arrayAllZero = [
    { kpiKey: '', stakeholder: '', sottoconto: 'A1', descrizione: '', perPrecGiust: '', perPrecValore: 0, perCorrGiust: '', perCorrValore: 0, perSuccGiust: '', perSuccValore: 0 },
    { kpiKey: '', stakeholder: '', sottoconto: 'A2', descrizione: '', perPrecGiust: '', perPrecValore: 0, perCorrGiust: '', perCorrValore: 0, perSuccGiust: '', perSuccValore: 0 },
    { kpiKey: '', stakeholder: '', sottoconto: 'B1', descrizione: '', perPrecGiust: '', perPrecValore: 0, perCorrGiust: '', perCorrValore: 0, perSuccGiust: '', perSuccValore: 0 },
    { kpiKey: '', stakeholder: '', sottoconto: 'B2', descrizione: '', perPrecGiust: '', perPrecValore: 0, perCorrGiust: '', perCorrValore: 0, perSuccGiust: '', perSuccValore: 0 },
    { kpiKey: '', stakeholder: '', sottoconto: 'B3', descrizione: '', perPrecGiust: '', perPrecValore: 0, perCorrGiust: '', perCorrValore: 0, perSuccGiust: '', perSuccValore: 0 },
    { kpiKey: '', stakeholder: '', sottoconto: 'B4', descrizione: '', perPrecGiust: '', perPrecValore: 0, perCorrGiust: '', perCorrValore: 0, perSuccGiust: '', perSuccValore: 0 },
    { kpiKey: '', stakeholder: '', sottoconto: 'B5', descrizione: '', perPrecGiust: '', perPrecValore: 0, perCorrGiust: '', perCorrValore: 0, perSuccGiust: '', perSuccValore: 0 },
    { kpiKey: '', stakeholder: '', sottoconto: 'B6', descrizione: '', perPrecGiust: '', perPrecValore: 0, perCorrGiust: '', perCorrValore: 0, perSuccGiust: '', perSuccValore: 0 },
    { kpiKey: '', stakeholder: '', sottoconto: 'B7', descrizione: '', perPrecGiust: '', perPrecValore: 0, perCorrGiust: '', perCorrValore: 0, perSuccGiust: '', perSuccValore: 0 },
    { kpiKey: '', stakeholder: '', sottoconto: 'C1', descrizione: '', perPrecGiust: '', perPrecValore: 0, perCorrGiust: '', perCorrValore: 0, perSuccGiust: '', perSuccValore: 0 },
    { kpiKey: '', stakeholder: '', sottoconto: 'C2', descrizione: '', perPrecGiust: '', perPrecValore: 0, perCorrGiust: '', perCorrValore: 0, perSuccGiust: '', perSuccValore: 0 },
    { kpiKey: '', stakeholder: '', sottoconto: 'C3', descrizione: '', perPrecGiust: '', perPrecValore: 0, perCorrGiust: '', perCorrValore: 0, perSuccGiust: '', perSuccValore: 0 },
    { kpiKey: '', stakeholder: '', sottoconto: 'E1', descrizione: '', perPrecGiust: '', perPrecValore: 0, perCorrGiust: '', perCorrValore: 0, perSuccGiust: '', perSuccValore: 0 },
    { kpiKey: '', stakeholder: '', sottoconto: 'F1', descrizione: '', perPrecGiust: '', perPrecValore: 0, perCorrGiust: '', perCorrValore: 0, perSuccGiust: '', perSuccValore: 0 },
    { kpiKey: '', stakeholder: '', sottoconto: 'G1', descrizione: '', perPrecGiust: '', perPrecValore: 0, perCorrGiust: '', perCorrValore: 0, perSuccGiust: '', perSuccValore: 0 },
    { kpiKey: '', stakeholder: '', sottoconto: 'H1', descrizione: '', perPrecGiust: '', perPrecValore: 0, perCorrGiust: '', perCorrValore: 0, perSuccGiust: '', perSuccValore: 0 },
    { kpiKey: '', stakeholder: '', sottoconto: 'L1', descrizione: '', perPrecGiust: '', perPrecValore: 0, perCorrGiust: '', perCorrValore: 0, perSuccGiust: '', perSuccValore: 0 },
  ]  
  
  const kpis = useSelector(
    (state) => state.questCorrente.kpis
  );


  // ELABORAZIONE PER VAR
  const allKpis = arrayAllZero.concat(kpis)
  const contoEconomico = useSelector(
    (state) => state.questCorrente.contoEconomico
  );

const grouped = allKpis.reduce((acc, curr) => {
  if (curr.sottoconto && curr.sottoconto.trim() !== '') {
    // const found = acc.find(item => curr.sottoconto.startsWith(acc));
    const found = acc.find(() => curr.sottoconto.startsWith(acc));

    if (found) {
      found.perCorrValore += curr.perCorrValore;
    } else {
      acc.push({ sottoconto: curr.sottoconto, perCorrValore: curr.perCorrValore });
    }
  }
  return acc;
}, []);

function groupBySottoconto(prefix) {
     return allKpis
    .filter(kpi => kpi.sottoconto.startsWith(prefix))
    .reduce((sum, kpi) => sum + kpi.perCorrValore, 0);
}

function groupByStakeholderComune() {
  return allKpis
 .filter(kpi =>  (kpi.stakeholder != '' && kpi.stakeholder != 'FR'))
 .reduce((sum, kpi) => sum + kpi.perCorrValore, 0);
}

  console.log(grouped);

  return (<>
    <Card className="text-center" ref={contentRef}>
      <Card.Body className="p-5">
        <Card.Title style={{marginBottom:"3%"}}>
          <h4 className="text-center">
            <strong>Valore Aggiunto Riattribuito (VAR)</strong>
          </h4>
        </Card.Title>
        <Card.Text>
          <Table bordered responsive>
            <thead>
              <tr>
                <th scope="col">Conto</th>
                <th scope="col" align="left">Descrizione</th>
                <th scope="col">Totale V.A. Aziendale</th>
                <th scope="col">Di cui non attribuiti<br />alla sostenibilità</th>
                <th scope="col">Di cui attribuiti<br /> alla sostenibilità<br />tramite la CSVC</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td></td>
                <td></td>
                <td><i>a</i></td>
                <td><i>b = a - c</i></td>
                <td><i>c</i></td>
               </tr>
              <tr>
                <td className="text-primary"><strong>A</strong></td>
                <td className="text-primary" align="left"><strong>TOTALE VALORE DELLA PRODUZIONE</strong></td>
                <td className="text-primary" align="right"><strong>
                  {contoEconomico.A1 + contoEconomico.A2}
                </strong></td>
                <td className="text-primary" align="right">
                  {(contoEconomico.A1 + contoEconomico.A2)-groupBySottoconto('A')}
                </td>
                <td className="text-primary" align="right"><strong>{groupBySottoconto('A')}</strong></td>
              </tr>
              <tr>
                <td>A.1</td>
                <td align="left">Principali</td>
                <td align="right">{contoEconomico.A1}</td>
                <td align="right">{contoEconomico.A1 - groupBySottoconto('A1')}</td>
                <td align="right">{groupBySottoconto('A1')}</td>
              </tr>
              <tr>
                <td>A.2</td>
                <td align="left">Altri</td>
                <td align="right">{contoEconomico.A2}</td>
                <td align="right">{contoEconomico.A2 - groupBySottoconto('A2')}</td>
                <td align="right">{groupBySottoconto('A2')}</td>
              </tr>

              <tr>
                <td className="text-primary"><strong>B</strong></td>
                <td className="text-primary" align="left"><strong>TOTALE COSTI INTERMEDI DELLA PRODUZIONE</strong></td>
                <td className="text-primary" align="right"><strong>
                  {contoEconomico.B1 + contoEconomico.B2 + contoEconomico.B3 + contoEconomico.B4 + contoEconomico.B5 + contoEconomico.B6 + contoEconomico.B7}
                </strong></td>
                <td className="text-primary" align="right"><strong>
                  {
                   (contoEconomico.B1 + contoEconomico.B2 + contoEconomico.B3 + contoEconomico.B4 + contoEconomico.B5 + contoEconomico.B6 + contoEconomico.B7)
                   - groupBySottoconto('B')
                  }
                </strong></td>
                <td className="text-primary" align="right"><strong>{groupBySottoconto('B')}</strong></td>
              </tr>
              <tr>
                <td>B.1</td>
                <td align="left">Consumi materie prime</td>
                <td align="right">{contoEconomico.B1}</td>
                <td align="right">{contoEconomico.B1 - groupBySottoconto('B1')}</td>
                <td align="right">{groupBySottoconto('B1')}</td>
              </tr>
              <tr>
                <td>B.2</td>
                <td align="left">Consumi materie sussidarie</td>
                <td align="right">{contoEconomico.B2}</td>
                <td align="right">{contoEconomico.B2 - groupBySottoconto('B2')}</td>
                <td align="right">{groupBySottoconto('B2')}</td>
              </tr>
              <tr>
                <td>B.3</td>
                <td align="left">Costi per servizi</td>
                <td align="right">{contoEconomico.B3}</td>
                <td align="right">{contoEconomico.B3 - groupBySottoconto('B3')}</td>
                <td align="right">{groupBySottoconto('B3')}</td>
              </tr>
              <tr>
                <td>B.4</td>
                <td align="left">Costi godimento beni di terzi</td>
                <td align="right">{contoEconomico.B4}</td>
                <td align="right">{contoEconomico.B4 - groupBySottoconto('B4')}</td>
                <td align="right">{groupBySottoconto('B4')}</td>
              </tr>
              <tr>
                <td>B.5</td>
                <td align="left">Accantonamento rischi vari</td>
                <td align="right">{contoEconomico.B5}</td>
                <td align="right">{contoEconomico.B5 - groupBySottoconto('B5')}</td>
                <td align="right">{groupBySottoconto('B5')}</td>
              </tr>
              <tr>
                <td>B.6</td>
                <td align="left">Oneri diversi di gestione</td>
                <td align="right">{contoEconomico.B6}</td>
                <td align="right">{contoEconomico.B6 - groupBySottoconto('B6')}</td>
                <td align="right">{groupBySottoconto('B6')}</td>
              </tr>
              <tr>
                <td>B.7</td>
                <td align="left">Personale non dipendente</td>
                <td align="right">{contoEconomico.B7}</td>
                <td align="right">{contoEconomico.B7 - groupBySottoconto('B7')}</td>
                <td align="right">{groupBySottoconto('B7')}</td>
              </tr>


              <tr>
                <td className="text-primary"><strong>C</strong></td>
                <td className="text-primary" align="left"><strong>TOTALE GESTIONE STRAORDINARIA</strong></td>
                <td className="text-primary" align="right"><strong>
                {contoEconomico.C1 + contoEconomico.C2 + contoEconomico.C3}
                </strong></td>
                <td className="text-primary" align="right"><strong>
                {(contoEconomico.C1 + contoEconomico.C2 + contoEconomico.C3) - groupBySottoconto('C')}
                </strong></td>
                <td className="text-primary" align="right"><strong>{groupBySottoconto('C')}</strong></td>
              </tr>
              <tr>
                <td>C.1</td>
                <td align="left">Ricavi accessori</td>
                <td align="right">{contoEconomico.C1}</td>
                <td align="right">{contoEconomico.C1 - groupBySottoconto('C1')}</td>
                <td align="right">{groupBySottoconto('C1')}</td>
              </tr>
              <tr>
                <td>C.2</td>
                <td align="left">Costi/ricavi straordinari</td>
                <td align="right">{contoEconomico.C2}</td>
                <td align="right">{contoEconomico.C2 - groupBySottoconto('C2')}</td>
                <td align="right">{groupBySottoconto('C2')}</td>
              </tr>
              <tr>
                <td>C.3</td>
                <td align="left">Ammortamenti della gestione</td>
                <td align="right">{contoEconomico.C3}</td>
                <td align="right">{contoEconomico.C3 - groupBySottoconto('C3')}</td>
                <td align="right">{groupBySottoconto('C3')}</td>
              </tr>
              {/*
                *  INIZIO CALCOLO D
              */}
                  <tr>
                    <td className="text-primary"><strong>D</strong></td>
                    <td className="text-primary" align="left"><strong>V.A. GLOBALE NETTO CREATO (A + B + C)</strong></td>
                    <td className="text-primary" align="right"><strong>{
                      (contoEconomico.A1 + contoEconomico.A2) +
                      (contoEconomico.B1 + contoEconomico.B2 + contoEconomico.B3 + contoEconomico.B4 + contoEconomico.B5 + contoEconomico.B6 + contoEconomico.B7) +
                      (contoEconomico.C1 + contoEconomico.C2 + contoEconomico.C3 )
                    }</strong></td>
                    <td className="text-primary" align="right"><strong>{
                      (contoEconomico.A1 + contoEconomico.A2) +
                      (contoEconomico.B1 + contoEconomico.B2 + contoEconomico.B3 + contoEconomico.B4 + contoEconomico.B5 + contoEconomico.B6 + contoEconomico.B7) +
                      (contoEconomico.C1 + contoEconomico.C2 + contoEconomico.C3 ) - 
                      (groupBySottoconto('A') + groupBySottoconto('B') + groupBySottoconto('C') )
                    }</strong></td>
                    <td className="text-primary" align="right"><strong>{
                      (groupBySottoconto('A') + groupBySottoconto('B') + groupBySottoconto('C') )
                      }</strong></td>
                  </tr>
              {/*
                *  FINE CALCOLO D
              */}
              <tr>
                <td className="text-primary"><strong>E</strong></td>
                <td className="text-primary" align="left"><strong>TOTALE REMUNERAZIONE PERSONALE</strong></td>
                <td className="text-primary" align="right"><strong>{contoEconomico.E1}</strong></td>
                <td className="text-primary" align="right"><strong>{contoEconomico.E1 - groupBySottoconto('E')}</strong></td>
                <td className="text-primary" align="right"><strong>{groupBySottoconto('E')}</strong></td>
              </tr>
              <tr>
                <td>E.1</td>
                <td align="left">Personale dipendente</td>
                <td align="right">{contoEconomico.E1}</td>
                <td align="right">{contoEconomico.E1 - groupBySottoconto('E1')}</td>
                <td align="right">{groupBySottoconto('E1')}</td>
              </tr>
 
              <tr>
                <td className="text-primary"><strong>F</strong></td>
                <td className="text-primary" align="left"><strong>TOTALE REMUNERAZIONE PUBBLICA AMMIN.NE</strong></td>
                <td className="text-primary" align="right"><strong>{contoEconomico.F1}</strong></td>
                <td className="text-primary" align="right"><strong>{contoEconomico.F1 - groupBySottoconto('F')}</strong></td>
                <td className="text-primary" align="right"><strong>{groupBySottoconto('F')}</strong></td>
              </tr>
              <tr>
                <td>F.1</td>
                <td align="left">Remunerazione Pubblica Amministrazione</td>
                <td align="right">{contoEconomico.F1}</td>
                <td align="right">{contoEconomico.F1 - groupBySottoconto('F1')}</td>
                <td align="right">{groupBySottoconto('F1')}</td>
              </tr>
 
              <tr>
                <td className="text-primary"><strong>G</strong></td>
                <td className="text-primary" align="left"><strong>TOTALE REMUNERAZIONE CAPITALE DI CREDITO</strong></td>
                <td className="text-primary" align="right"><strong>{contoEconomico.G1}</strong></td>
                <td className="text-primary" align="right"><strong>{contoEconomico.G1 - groupBySottoconto('G1')}</strong></td>
                <td className="text-primary" align="right"><strong>{groupBySottoconto('G')}</strong></td>
              </tr>
              <tr>
                <td>G.1</td>
                <td align="left">Remunerazione capitale di credito</td>
                <td align="right">{contoEconomico.G1}</td>
                <td align="right">{contoEconomico.G1 - groupBySottoconto('G1')}</td>
                <td align="right">{groupBySottoconto('G1')}</td>
              </tr>

              
              <tr>
                <td className="text-primary"><strong>H</strong></td>
                <td className="text-primary" align="left"><strong>TOTALE LIBERALITÀ ESTERNE</strong></td>
                <td className="text-primary" align="right"><strong>{contoEconomico.H1}</strong></td>
                <td className="text-primary" align="right"><strong>{contoEconomico.H1 - groupBySottoconto('H')}</strong></td>
                <td className="text-primary" align="right"><strong>{groupBySottoconto('H')}</strong></td>
              </tr>
              <tr>
                <td>H.1</td>
                <td align="left">Liberalità esterne</td>
                <td align="right">{contoEconomico.H1}</td>
                <td align="right">{contoEconomico.H1 - groupBySottoconto('H1')}</td>
                <td align="right">{groupBySottoconto('H1')}</td>
              </tr>
              {/*
                *  INIZIO CALCOLO I
              */}
              <tr>
                <td className="text-primary"><strong>I</strong></td>
                <td className="text-primary" align="left"><strong>TOTALE REMUNERAZIONE STAKEHOLDER (E + F + G + H)</strong></td>
                <td className="text-primary" align="right"><strong>{
                  (contoEconomico.E1 + contoEconomico.F1 + contoEconomico.G1 + contoEconomico.H1)
                }</strong></td>
                <td className="text-primary" align="right"><strong>{
                  (contoEconomico.E1 + contoEconomico.F1 + contoEconomico.G1 + contoEconomico.H1)-
                  (groupBySottoconto('E') + groupBySottoconto('F') + groupBySottoconto('G') + groupBySottoconto('H'))
                }</strong></td>
                <td className="text-primary" align="right"><strong>{
                  groupBySottoconto('E') + groupBySottoconto('F') + groupBySottoconto('G') + groupBySottoconto('H') 
                  }</strong></td>
              </tr>
              {/*
                *  FINE CALCOLO I
              */}
              <tr>
                <td className="text-primary"><strong>L</strong></td>
                <td className="text-primary" align="left"><strong>COSTI DIVERSI</strong></td>
                <td className="text-primary" align="right"><strong>{contoEconomico.L1}</strong></td>
                <td className="text-primary" align="right"><strong>{contoEconomico.L1 - groupBySottoconto('L')}</strong></td>
                <td className="text-primary" align="right"><strong>{groupBySottoconto('L')}</strong></td>
              </tr>
 
              <tr>
                <td>L.1</td>
                <td align="left">Costi diversi</td>
                <td align="right">{contoEconomico.L1}</td>
                <td align="right">{contoEconomico.L1 - groupBySottoconto('L1')}</td>
                <td align="right">{groupBySottoconto('L1')}</td>
              </tr>
              {/*
                *  INIZIO CALCOLO M
              */}
              <tr>
                <td className="text-primary"><strong>M</strong></td>
                <td className="text-primary" align="left"><strong>TOTALE COSTI (B + C + I + L)</strong></td>
                <td className="text-primary" align="right"><strong>{
                      (contoEconomico.B1 + contoEconomico.B2 + contoEconomico.B3 + contoEconomico.B4 + contoEconomico.B5 + contoEconomico.B6 + contoEconomico.B7) +
                      (contoEconomico.C1 + contoEconomico.C2 + contoEconomico.C3)+
                      (contoEconomico.E1 + contoEconomico.F1 + contoEconomico.G1 + contoEconomico.H1) +
                      (contoEconomico.L1)
                }</strong></td>
                <td className="text-primary" align="right"><strong>{
                  ((contoEconomico.B1 + contoEconomico.B2 + contoEconomico.B3 + contoEconomico.B4 + contoEconomico.B5 + contoEconomico.B6 + contoEconomico.B7) +
                  (contoEconomico.C1 + contoEconomico.C2 + contoEconomico.C3)+
                  (contoEconomico.E1 + contoEconomico.F1 + contoEconomico.G1 + contoEconomico.H1) +
                  (contoEconomico.L1)) - 
                  ( groupBySottoconto('B') + groupBySottoconto('C') + groupBySottoconto('L') +
                  groupBySottoconto('E') + groupBySottoconto('F') + groupBySottoconto('G') + groupBySottoconto('H') )
                }</strong></td>
                <td className="text-primary" align="right"><strong>{
                  groupBySottoconto('B') + groupBySottoconto('C') + groupBySottoconto('L') +
                  groupBySottoconto('E') + groupBySottoconto('F') + groupBySottoconto('G') + groupBySottoconto('H') 
                  }</strong></td>
              </tr>
              {/*
                *  FINE CALCOLO M
                *
                *  INIZIO CALCOLO N
              */}
              <tr>
                <td className="text-primary"><strong>N</strong></td>
                <td className="text-primary" align="left"><strong>REMUNERAZIONE AZIENDA (D + I)</strong></td>
                <td className="text-primary" align="right"><strong>{
                  
                  ((contoEconomico.A1 + contoEconomico.A2) +
                  (contoEconomico.B1 + contoEconomico.B2 + contoEconomico.B3 + contoEconomico.B4 + contoEconomico.B5 + contoEconomico.B6 + contoEconomico.B7) +
                  (contoEconomico.C1 + contoEconomico.C2 + contoEconomico.C3 ))
                  +
                  (contoEconomico.E1 + contoEconomico.F1 + contoEconomico.G1 + contoEconomico.H1)
                  }</strong></td>
                <td className="text-primary" align="right"><strong>
                 {
                  (((contoEconomico.A1 + contoEconomico.A2) +
                  (contoEconomico.B1 + contoEconomico.B2 + contoEconomico.B3 + contoEconomico.B4 + contoEconomico.B5 + contoEconomico.B6 + contoEconomico.B7) +
                  (contoEconomico.C1 + contoEconomico.C2 + contoEconomico.C3 ))
                  +
                  (contoEconomico.E1 + contoEconomico.F1 + contoEconomico.G1 + contoEconomico.H1))
                  -
                  ((groupBySottoconto('A') + groupBySottoconto('B') + groupBySottoconto('C') ) +
                  (groupBySottoconto('E') + groupBySottoconto('F') + groupBySottoconto('G') + groupBySottoconto('H') ))
                 }</strong></td>
                <td className="text-primary" align="right"><strong>{
                  (groupBySottoconto('A') + groupBySottoconto('B') + groupBySottoconto('C') ) +
                  (groupBySottoconto('E') + groupBySottoconto('F') + groupBySottoconto('G') + groupBySottoconto('H') )
                  }</strong></td>
              </tr>
              {/*
                *  FINE CALCOLO N
                *
                *  INIZIO CALCOLO O
              */}
              <tr>
                <td className="text-primary"><strong>O</strong></td>
                <td className="text-primary" align="left"><strong>TOTALE V.A. DISTRIBUITO (I - N)</strong></td>
                <td className="text-primary" align="right"><strong>{
                  (contoEconomico.E1 + contoEconomico.F1 + contoEconomico.G1 + contoEconomico.H1) -
                  (((contoEconomico.A1 + contoEconomico.A2) +
                  (contoEconomico.B1 + contoEconomico.B2 + contoEconomico.B3 + contoEconomico.B4 + contoEconomico.B5 + contoEconomico.B6 + contoEconomico.B7) +
                  (contoEconomico.C1 + contoEconomico.C2 + contoEconomico.C3 ))
                  +
                  (contoEconomico.E1 + contoEconomico.F1 + contoEconomico.G1 + contoEconomico.H1))
                } </strong></td>
                <td className="text-primary" align="right"><strong>{
                (
                  (contoEconomico.E1 + contoEconomico.F1 + contoEconomico.G1 + contoEconomico.H1) -
                  (((contoEconomico.A1 + contoEconomico.A2) +
                  (contoEconomico.B1 + contoEconomico.B2 + contoEconomico.B3 + contoEconomico.B4 + contoEconomico.B5 + contoEconomico.B6 + contoEconomico.B7) +
                  (contoEconomico.C1 + contoEconomico.C2 + contoEconomico.C3 ))
                  +
                  (contoEconomico.E1 + contoEconomico.F1 + contoEconomico.G1 + contoEconomico.H1))
                )
                -
                (
                  (groupBySottoconto('E') + groupBySottoconto('F') + groupBySottoconto('G') + groupBySottoconto('H') ) -
                  (
                    (groupBySottoconto('A') + groupBySottoconto('B') + groupBySottoconto('C') ) +
                    (groupBySottoconto('E') + groupBySottoconto('F') + groupBySottoconto('G') + groupBySottoconto('H') )
                  )
                )
                }</strong></td>
                <td className="text-primary" align="right"><strong>{
                    (groupBySottoconto('E') + groupBySottoconto('F') + groupBySottoconto('G') + groupBySottoconto('H') ) -
                    (
                      (groupBySottoconto('A') + groupBySottoconto('B') + groupBySottoconto('C') ) +
                      (groupBySottoconto('E') + groupBySottoconto('F') + groupBySottoconto('G') + groupBySottoconto('H') )
                    )
                  }</strong></td>
              </tr>
              {/*
                *  FINE CALCOLO O
              */}
              <tr>
                <td></td>
                <td className="text-primary" align="right" colSpan={3}><strong>Totale valore creato per gli stakeholder comuni</strong></td>
                <td className="text-primary" align="right"><strong>{ groupByStakeholderComune() }</strong></td>
              </tr>
            </tbody>
          </Table>

        </Card.Text>
      </Card.Body>
    </Card>
    <Button onClick={() => handleScatterPrint()}  className="mt-3">Stampa</Button>

  </>);
};

export default ValoreAggiuntoRiattribuito;
